import React from 'react';
import TopQuestion from '../../utils/question/topQuestion';
import { connect } from 'react-redux';
import SpeechRecorder from '../sa/saSpeechRecorder';
import TextArea from '../../utils/test/textarea';

const mapStateToProps = (state) => {
	const {
		rightSectionProps: { choices },
		leftSectionProps: { videoId, question, imagesrc, queDesc, qdomain, prompt },
	} = state.rootReducer.testPageDetails;

	return {
		choices,
		videoId,
		question,
		imagesrc,
		queDesc,
		qdomain,
		prompt,
	};
};
const SaSpeech = ({
	choices,
	videoId,
	question,
	imagesrc,
	queDesc,
	qdomain,
	prompt,
}) => {
	return (
		<section className="que-container">
			<section className="quiz-page-content">
				<TopQuestion />
				<section className="quiz-area-options">
					<h6>{prompt}</h6>
					{qdomain === 'S' ? <SpeechRecorder /> : <TextArea />}
				</section>
			</section>
		</section>
	);
};

export default connect(mapStateToProps)(SaSpeech);
